module.exports = __webpack_public_path__ + "static/media/3dprinterscanner.82e4ecfb.png";